<div matDialogTitle>{{ 'Proprietà azione' | siaTranslate }}</div>

<div matDialogContent>
  <div class="mt-2 flex flex-row flex-wrap gap-2 overflow-hidden pt-2">
    <sia-select-box
      [selectBoxOptions]="{
        value: action.modeBeforeFire,
        fixedDataSource: pageModesSelect,
      }"
      [disabled]="true"
      label="Modalità prima di eseguire"
      [(value)]="action.modeBeforeFire"
    ></sia-select-box>
    <sia-select-box
      [selectBoxOptions]="{
        value: action.modeAfterFire,
        fixedDataSource: pageModesSelect,
      }"
      [disabled]="false"
      label="Modalità dopo esecuzione"
      [(value)]="action.modeAfterFire"
    ></sia-select-box>
    <sia-check-box label="Statica" [(value)]="action.isStatic"></sia-check-box>
    <sia-select-box
      [selectBoxOptions]="{
        value: action.style,
        fixedDataSource: actionStyles,
      }"
      [disabled]="false"
      label="Stile azione"
      [(value)]="action.style"
    >
    </sia-select-box>
    <sia-js-editor
      title="Script azione"
      [(jsCode)]="action.script"
      class="w-full"
    ></sia-js-editor>
    <sia-js-editor
      title="Script visibilità"
      [(jsCode)]="action.visibilityScript"
      class="w-full"
    ></sia-js-editor>
  </div>
</div>

<div matDialogActions align="end">
  <button mat-button (click)="saveAction()">
    {{ 'Salva' | siaTranslate }}
  </button>
  <button mat-button (click)="closeDialog()" class="button-grey">
    {{ 'Annulla' | siaTranslate }}
  </button>
</div>
